import axios from 'axios';
import { useQuery } from 'react-query';
import { Case } from '../api/responses';

export const useGetCase = (id?: string) => {
    const getCase = async (): Promise<Case> => {
        const caseBank = await axios.get(`${process.env.REACT_APP_API_URL}/cases/${id}/`).then((res) => res.data)
        return caseBank;
    };
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['get-case'],
        queryFn: getCase,
        enabled: !!id
    });

    return { data, isError, isLoading, error };
};
